import type { VoidFunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { Header } from '../../../../shared/vulns/Drawer';
import * as PackageInventoryStore from '../../../../../redux/packageInventory';
import EpssBadge from '../../../../issues/IssuesInbox/IssueItem/EpssBadge';
import CVEBadge from '../../../../issues/IssuesInbox/IssueItem/CVEBadge';
import { Exploitability } from '../../../../../../shared/vulns/types';
import KnownExploitBadge from '../../../../issues/IssuesInbox/IssueItem/KnownExploitBadge';
import { isLinuxFetcher } from '../../../../../../shared/fetchers';
import FixBadge from '../../../../issues/IssuesInbox/IssueItem/FixBadge';

/**
 * Container component for the VulnerabilityDrawerHeader
 */
const PackageVersionVulnerabilityDrawerHeader: VoidFunctionComponent = () => {
  const { isLoading } = useSelector(PackageInventoryStore.selectors.getAsyncStatusGetSelectedVuln);
  const title = useSelector(PackageInventoryStore.selectors.getSelectedVulnTitle);
  const cvss = useSelector(PackageInventoryStore.selectors.getSelectedVulnCvss);
  const cve = useSelector(PackageInventoryStore.selectors.getSelectedVulnCve);
  const epss = useSelector(PackageInventoryStore.selectors.getSelectedVulnEpss);
  const exploitability = useSelector(PackageInventoryStore.selectors.getExploitability);
  const locatorParts = useSelector(PackageInventoryStore.selectors.getPackageVersionMetadataLocatorParts);
  const remediation = useSelector(PackageInventoryStore.selectors.getSelectedVulnRemediation);
  const isLinuxDep = isLinuxFetcher(locatorParts?.fetcher);
  const shouldShowFixBadge = remediation && !isLinuxDep;

  return (
    <Header
      isLoading={isLoading}
      title={title}
      cvss={cvss}
      locatorParts={locatorParts}
      badgesSlot={
        <>
          {epss && <EpssBadge tooltipId={`epss-badge-${cve}`} epss={epss} showTooltip={false} />}
          {shouldShowFixBadge && (
            <FixBadge
              version={remediation.partialFix}
              distance={remediation.partialFixDistance}
              showTooltip={false}
            />
          )}
          {cve && <CVEBadge cve={cve} showTooltip={false} /> }
          {exploitability !== Exploitability.Unknown && <KnownExploitBadge showTooltip={false} />}
        </>
      }
    />
  );
};

export default PackageVersionVulnerabilityDrawerHeader;
